import { render, staticRenderFns } from "./simbiosis-web.html?vue&type=template&id=1444fc17&"
import script from "./simbiosis-web.ts?vue&type=script&lang=ts&"
export * from "./simbiosis-web.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports